import instance from '..';

const getProfile = () => instance.get('/profile/get');

export default getProfile;
